import React, { useContext, useEffect, useState } from 'react'
import Aside from '../../component/aside'
import Navbar from '../../component/navbar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faCommentAlt,
    faInbox,
    faPaperPlane,
    faPen,
} from '@fortawesome/free-solid-svg-icons'
import Loading from '../../component/loading'
import RequestQueue from '../../api/requestQueue'
import { toast } from 'react-toastify'
import { AppContextMenu } from '../../App'

const SendAnonymousMessage = () => {
    const { updateValue } = useContext(AppContextMenu)
    useEffect(() => {
        updateValue('sendAnonymousMessage')
    }, [])
    const [loading, setLoading] = useState(false)

    const [message, setMessage] = useState('')

    const handleSubmit = async () => {
        setLoading(true)

        await RequestQueue.sendRequest({
            config: {
                method: 'post',
                url: `/anonymous-message`,
                data: {
                    content: message,
                },
            },
            resolve: (res) => {
                toast.dismiss()
                toast.success('پیام شما با موفقیت ارسال شد', {
                    position: 'bottom-center',
                })
                setMessage('')
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سزوز', {
                    position: 'bottom-center',
                })
            },
        })
    }

    return (
        <>
            {loading && <Loading />}
            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />

                    <div className="bg-white rounded-xl shadow-lg  border border-gray-200 mx-4 my-6">
                        {/* Header */}
                        <div className="px-6 py-5 border-b border-gray-200 bg-gradient-to-r from-indigo-600 to-purple-600">
                            <h2 className="text-2xl font-bold text-white">
                                <FontAwesomeIcon
                                    icon={faCommentAlt}
                                    className="ml-2"
                                />
                                ارسال پیام ناشناس
                            </h2>
                        </div>

                        {/* Form Content */}
                        <div className="p-6 space-y-6">
                            {/* Message Form */}
                            <div className="space-y-2">
                                <label className=" text-sm font-medium text-gray-700 flex items-center">
                                    <FontAwesomeIcon
                                        icon={faPen}
                                        className="ml-2"
                                    />
                                    پیام شما
                                </label>
                                <textarea
                                    rows={4}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                    placeholder="متن پیام خود را اینجا بنویسید..."
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                ></textarea>
                            </div>

                            {/* Form Actions */}
                            <div className="flex justify-end space-x-3 space-x-reverse pt-6 maxLg:flex-col">
                                <button
                                    type="button"
                                    onClick={handleSubmit}
                                    className="px-6 py-3 rounded-xl text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all shadow-md hover:shadow-lg flex items-center"
                                >
                                    <FontAwesomeIcon
                                        icon={faPaperPlane}
                                        className="ml-2"
                                    />
                                    ارسال پیام
                                </button>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}
export default SendAnonymousMessage
